module.exports = __webpack_public_path__ + "officialStatic/img/productHardwareMid.3e692b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/productHardwareMid.png
// module id = d1BB
// module chunks = 0